module.exports = __webpack_public_path__ + "img/st.cbe217ea.png";